module.exports = __webpack_public_path__ + "static/media/checkon.4661bc06.svg";